import RevenuePage from './RevenuePage'
import { revenuMenu } from './sideBarOption'

export default RevenuePage
export { revenuMenu }
